module.exports = __webpack_public_path__ + "img/6.2cc8c804.png";